(function () {
  'use strict';

  function labelFor(picker, checked) {
    if (checked.length === 0) return 'Tutte le marche';
    if (checked.length === 1) return checked[0].value;
    return `${checked.length} marche selezionate`;
  }

  function updateSummary(picker) {
    const checked = Array.from(picker.querySelectorAll('input[name="brand"]:checked'));
    const total = picker.querySelectorAll('input[name="brand"]:not(:disabled)').length;
    const label = picker.querySelector('[data-brand-picker-label]');
    const count = picker.querySelector('[data-brand-picker-count]');
    if (label) label.textContent = labelFor(picker, checked);
    if (count) count.textContent = `${checked.length} / ${total}`;
    picker.querySelectorAll('[data-brand-picker-group]').forEach((group) => {
      const items = Array.from(group.querySelectorAll('input[name="brand"]:not(:disabled)'));
      const groupToggle = group.querySelector('[data-brand-picker-group-toggle]');
      if (groupToggle) groupToggle.checked = items.length > 0 && items.every((i) => i.checked);
    });
  }

  const isMobile = () => window.matchMedia('(max-width: 1023px)').matches;

  // Il pannello usa position:fixed (non absolute) per sfuggire del tutto al
  // contesto di stacking/overflow della card hero che lo contiene: su
  // desktop calcoliamo qui le coordinate rispetto al trigger, sul mobile la
  // CSS lo ancora già al bordo inferiore dello schermo (foglio a comparsa),
  // quindi non tocchiamo top/left in quel caso.
  function positionPanel(picker) {
    const trigger = picker.querySelector('[data-brand-picker-trigger]');
    const panel = picker.querySelector('[data-brand-picker-panel]');
    if (!trigger || !panel || panel.hidden) return;
    if (isMobile()) {
      const viewport = window.visualViewport;
      const height = Math.max(280, viewport ? viewport.height : window.innerHeight);
      const bottom = Math.max(0, window.innerHeight - height - (viewport ? viewport.offsetTop : 0));
      panel.style.setProperty('--brand-visible-height', `${Math.max(280, height - 8)}px`);
      panel.style.setProperty('--brand-keyboard-inset', `${bottom}px`);
      panel.style.top = '';
      panel.style.left = '';
      panel.style.width = '';
      return true;
    }
    panel.style.removeProperty('--brand-visible-height');
    panel.style.removeProperty('--brand-keyboard-inset');
    const rect = trigger.getBoundingClientRect();
    if (rect.bottom < 0 || rect.top > window.innerHeight) return false;
    const panelWidth = Math.min(380, window.innerWidth * 0.9);
    let left = rect.left;
    if (left + panelWidth > window.innerWidth - 12) left = window.innerWidth - panelWidth - 12;
    if (left < 12) left = 12;
    const panelHeight = Math.min(panel.offsetHeight || 420, window.innerHeight - 24);
    const below = window.innerHeight - rect.bottom - 8;
    const top = below >= panelHeight || below >= rect.top ? rect.bottom + 8 : Math.max(12, rect.top - panelHeight - 8);
    panel.style.left = `${left}px`;
    panel.style.top = `${top}px`;
    panel.style.width = `${panelWidth}px`;
    return true;
  }

  function openPanel(picker) {
    const panel = picker.querySelector('[data-brand-picker-panel]');
    const backdrop = picker.querySelector('[data-brand-picker-backdrop]');
    const trigger = picker.querySelector('[data-brand-picker-trigger]');
    document.querySelectorAll('[data-brand-picker]').forEach((other) => {
      if (other !== picker && !other.querySelector('[data-brand-picker-panel]').hidden) closePanel(other, false);
    });
    panel.hidden = false;
    if (typeof panel.showPopover === 'function') {
      panel.setAttribute('popover', 'manual');
      panel.showPopover();
    }
    backdrop.hidden = false;
    trigger.setAttribute('aria-expanded', 'true');
    document.documentElement.classList.add('brand-picker-open');
    positionPanel(picker);
    const search = picker.querySelector('[data-brand-picker-search]');
    const focusTarget = isMobile() ? picker.querySelector('[data-brand-picker-close]') : search;
    if (focusTarget) window.requestAnimationFrame(() => {
      if (!panel.hidden) focusTarget.focus({ preventScroll: true });
    });
  }

  function closePanel(picker, restoreFocus = true) {
    const panel = picker.querySelector('[data-brand-picker-panel]');
    const backdrop = picker.querySelector('[data-brand-picker-backdrop]');
    const trigger = picker.querySelector('[data-brand-picker-trigger]');
    panel.style.top = '';
    panel.style.left = '';
    panel.style.width = '';
    panel.style.removeProperty('--brand-visible-height');
    panel.style.removeProperty('--brand-keyboard-inset');
    if (panel.contains(document.activeElement)) document.activeElement.blur();
    if (typeof panel.hidePopover === 'function' && panel.matches(':popover-open')) panel.hidePopover();
    panel.hidden = true;
    backdrop.hidden = true;
    trigger.setAttribute('aria-expanded', 'false');
    document.documentElement.classList.remove('brand-picker-open');
    if (restoreFocus) trigger.focus({ preventScroll: true });
  }

  function filterList(picker, term) {
    const query = term.trim().toLowerCase();
    let anyVisible = false;
    picker.querySelectorAll('[data-brand-picker-group]').forEach((group) => {
      let groupHasVisible = false;
      group.querySelectorAll('[data-brand-picker-item]').forEach((item) => {
        const match = item.dataset.unavailable !== 'true' && (!query || item.dataset.brandName.includes(query));
        item.hidden = !match;
        if (match) groupHasVisible = true;
      });
      group.hidden = !groupHasVisible;
      if (groupHasVisible) anyVisible = true;
    });
    const empty = picker.querySelector('[data-brand-picker-empty]');
    if (empty) empty.hidden = anyVisible;
  }

  function initPicker(picker) {
    if (picker.dataset.brandPickerInitialized) return;
    picker.dataset.brandPickerInitialized = 'true';

    const trigger = picker.querySelector('[data-brand-picker-trigger]');
    const closeBtn = picker.querySelector('[data-brand-picker-close]');
    const backdrop = picker.querySelector('[data-brand-picker-backdrop]');
    const applyBtn = picker.querySelector('[data-brand-picker-apply]');
    const search = picker.querySelector('[data-brand-picker-search]');
    const selectAllBtn = picker.querySelector('[data-brand-picker-select-all]');
    const clearBtn = picker.querySelector('[data-brand-picker-clear]');

    trigger.addEventListener('click', () => openPanel(picker));
    closeBtn.addEventListener('click', () => closePanel(picker));
    backdrop.addEventListener('click', () => closePanel(picker));
    applyBtn.addEventListener('click', () => {
      const selected = Array.from(picker.querySelectorAll('input[name="brand"]:checked:not(:disabled)'), (input) => input.value);
      picker.dispatchEvent(new CustomEvent('brand-picker:apply', {
        bubbles: true,
        detail: { brands: selected }
      }));
      closePanel(picker, false);
    });

    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && !picker.querySelector('[data-brand-picker-panel]').hidden) closePanel(picker);
    });

    let frame = 0;
    const reposition = () => {
      if (frame) return;
      frame = window.requestAnimationFrame(() => {
        frame = 0;
        const panel = picker.querySelector('[data-brand-picker-panel]');
        if (panel && !panel.hidden && positionPanel(picker) === false) closePanel(picker, false);
      });
    };
    window.addEventListener('resize', reposition, { passive: true });
    window.addEventListener('scroll', reposition, { passive: true });
    if (window.visualViewport) {
      window.visualViewport.addEventListener('resize', reposition, { passive: true });
      window.visualViewport.addEventListener('scroll', reposition, { passive: true });
    }
    search.addEventListener('input', () => filterList(picker, search.value));
    search.addEventListener('focus', reposition);

    selectAllBtn.addEventListener('click', () => {
      picker.querySelectorAll('[data-brand-picker-item]:not([hidden]) input[name="brand"]:not(:disabled)').forEach((cb) => { cb.checked = true; });
      updateSummary(picker);
      picker.closest('form')?.dispatchEvent(new Event('change', {bubbles:true}));
    });
    clearBtn.addEventListener('click', () => {
      picker.querySelectorAll('input[name="brand"]:not(:disabled)').forEach((cb) => { cb.checked = false; });
      updateSummary(picker);
      picker.closest('form')?.dispatchEvent(new Event('change', {bubbles:true}));
    });

    picker.querySelectorAll('[data-brand-picker-group-toggle]').forEach((groupToggle) => {
      groupToggle.addEventListener('change', () => {
        const group = groupToggle.closest('[data-brand-picker-group]');
        group.querySelectorAll('[data-brand-picker-item]:not([hidden]) input[name="brand"]:not(:disabled)').forEach((cb) => { cb.checked = groupToggle.checked; });
        updateSummary(picker);
      });
    });

    picker.addEventListener('change', (event) => {
      if (event.target.name === 'brand') updateSummary(picker);
    });

    picker.addEventListener('catalog:brands-updated', () => {updateSummary(picker);filterList(picker,search.value);});
    updateSummary(picker);
  }

  document.addEventListener('gommadot:content-updated', () => document.querySelectorAll('[data-brand-picker]').forEach(initPicker));
  document.querySelectorAll('[data-brand-picker]').forEach(initPicker);
  document.addEventListener('shopify:section:load', (event) => event.target.querySelectorAll('[data-brand-picker]').forEach(initPicker));
})();
